// src/i18n/AppLocale.ts
import enLang from "./entries/en-US"
import zhLang from "./entries/zh-Hans-CN"
import arLang from "./entries/ar_SA"
import itLang from "./entries/it_IT"
import esLang from "./entries/es_ES"
import frLang from "./entries/fr_FR"
import thLang from "./entries/th_TH"

// ไม่มีการใช้ addLocaleData อีกต่อไป

const AppLocale = {
  en: enLang,
  zh: zhLang,
  ar: arLang,
  it: itLang,
  es: esLang,
  fr: frLang,
  th: thLang
}

export default AppLocale

